// extracted by mini-css-extract-plugin
module.exports = {"left_img":"leftImageRightNews-m__left_img__2vxV3","news_item":"leftImageRightNews-m__news_item__2Fqft"};